import React, { useState } from "react"
import { colorsByType } from "./sc-analyzer-frontend-data"
import { gotoAST } from "./gotoAST"
import CircularProgressBar from "src/components/circular-progress-bar"
import Tooltip from "src/components/tooltip"
import { goToFile } from "src/components/icons-svg"
/**
 * @param props {{
 * resource:import("../../../backend/sc_analyzer/sc_analyzer-interface").oneElement
 * showProgress: boolean
 * cardElementType: string
 * scState:scState
 *  }}
 */
export default function OneResource({
  scState,
  resource,
  showProgress = true,
  cardElementType = "",
}) {
  var { name, type, displayName } = resource
  var isSelected =
    resource?.displayName == scState.selectedResource?.displayName

  const onGoToFile = () => {
    if (resource.declaredInFile) {
      scState.set_selectedFile(resource.declaredInFile)
    }
    scState.set_selectedResource(resource)
    // if(resource.gotoTab) {
    //   scState.set_selectedResourseType(resource.gotoTab)
    // }
    if (resource.astId) {
      setTimeout(() => {
        gotoAST(resource.astId)
      })
    }
  }
  return (
    <div
      css={`
        display: flex;
        align-items: center;
      `}
    >
      <div css="position: relative">
        <Tooltip
          tip={(displayName || name).length > 30 ? displayName || name : ""}
        >
          <div
            onClick={() => {
              if (
                (resource.hasOwnProperty("inUse") &&
                  resource["inUse"].length > 0) ||
                (!resource.hasOwnProperty("inUse") &&
                  cardElementType !== "expandable-path-resources")
              ) {
                onGoToFile()
              }
            }}
            css={`
              border: ${isSelected
                ? `3px solid #000000`
                : `1px solid rgba(0,0,0,0.047)`};
              display: inline-flex;
              padding: ${isSelected ? `1px 1px` : `3px 3px`};
              font-size: 16px;
              border-radius: 8px;
              cursor: ${(resource.inUse?.length > 0 ||
                !resource.hasOwnProperty("inUse")) &&
              cardElementType !== "expandable-path-resources"
                ? "pointer"
                : "not-allowed"};
              ${isSelected ? "box-shadow:2px 2px 2px #000000b8" : ""};
              background-color: ${resource.color_bg};
              color: ${resource.color_fg};
            `}
          >
            {(displayName || name).length > 30
              ? `${(displayName || name).substring(0, 27)}...`
              : displayName || name}
          </div>
        </Tooltip>
        {showProgress && (resource.inUse?.length > 0 ||
                !resource.hasOwnProperty("inUse")) && (
          <div
            css="position: absolute;
        top: -4px;
        right: -4px;"
          >
            <CircularProgressBar
              height={12}
              width={12}
              progress={Math.floor(
                // @ts-ignore
                scState.getProgressForResource(resource.astId).total === 0
                  ? 0
                  : (scState.getProgressForResource(resource.astId).completed /
                      scState.getProgressForResource(resource.astId).total) *
                      100,
              )}
            />
          </div>
        )}
      </div>
      {cardElementType === "expandable-path-resources" && (
        <Tooltip tip={"Go to file"}>
          <div
            css={`
              cursor: pointer;
              color: blue;
              text-decoration: underline;
              padding-left: 5px;
            `}
            onClick={() => {
              onGoToFile()
            }}
          >
            {goToFile(20)}
          </div>
        </Tooltip>
      )}
    </div>
  )
}
